import router from './router'
import store from './store'
import { notification } from 'ant-design-vue'
import { chatLogin } from '@/api/chat.js'
import { getToken, removeToken } from '@/utils/auth' // get token from cookie
import { initIccc } from '@/utils/Tccc'

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      // 获取用户 userId 以及环信id
      const hasIdInfo = !!(store.getters.userId && store.getters.chatId)
      if (hasIdInfo) {
        next()
      } else {
        try {
          // 用户坐班状态等信息
          await store.dispatch('user/getUserInfo')
          // 获取坐班状态及相关配置
          await store.dispatch('user/queryShiftStaus')
          await store.dispatch('alarm/getLoginAlarmInfo')
          // 获取工单类型字典
          await store.dispatch('user/setWorkorderMap')
          chatLogin(store.getters.chatId)
          initIccc()
          store.dispatch('tccc/getCallunProcessedCount')
          store.dispatch('alarm/getUnProcessAlarmReadFlag')
          // 获取用户是否开启已读未读展示功能
          store.dispatch('user/setOpenImReadAck')
          // 开始收集临回滚工单
          store.dispatch('rollBack/getAllRefreshTimer')
          next()
        } catch (error) {
          removeToken()
          notification.error({
            message: 'Has Error',
            description: error
          })
          next('/login')
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next('/login')
    }
  }
})

router.afterEach(() => {})
